import "./Map.scss";

import React from "react";
import { observer, inject } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import { STORE_MAP } from "../../Store/MapStore";
import MapVehicle from "./MapVehicle";
import MapCorridor from "./MapCorridor";
import MapArea from "./MapArea";
import { React as Selectivity } from "selectivity/react";
import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_TABLE, ROUTE_MAP } from "../../routes";

import { formatDateOnly } from "utility.js";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

//const CSSTransitionGroup = React.addons.CSSTransitionGroup
//const TransitionGroup = React.addons.TransitionGroup
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import { PRINT_TEMPLATE } from "./printTemplate";

const DIRECTION_TOP = 0;
const DIRECTION_RIGHT = 1;
const DIRECTION_BOTTOM = 2;
const DIRECTION_LEFT = 3;

const numberFormatter = new Intl.NumberFormat();

function getDirectionFromVector(x, y) {
  return x === 1
    ? DIRECTION_RIGHT
    : y === 1
      ? DIRECTION_BOTTOM
      : x === -1
        ? DIRECTION_LEFT
        : DIRECTION_TOP;
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

@inject((stores) => ({
  store: stores.store.get(STORE_MAP),
  configStore: stores.store.get(STORE_CONFIG),
  currentWarehouseId: stores.store.get(STORE_MAP).currentWarehouseId,
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Map extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  refreshMap = () => {
    const { store, socket, route, configStore } = this.props;

    socket.emitWithToken("GetMap", {}, (err, data) => {
      if (err) {
        console.error(err);
        return;
      }

      if (data.Warehouses && data.Warehouses.length) {
        if (store.detailedBinId) {
          socket.emitWithToken(
            "GetBinData",
            { BinId: store.detailedBinId },
            (err, data) => {
              if (err) {
                console.error("GetBinData", err);
                return;
              }
              store.setBinDetails(store.detailedBinId, data);
            },
          );
        }

        if (route.params.hasOwnProperty("defaultDetailedBin")) {
          const bin = route.params.defaultDetailedBin;

          for (let i = 0; i < configStore.bins.length; i++) {
            if (configStore.bins[i].name === bin) {
              store.setCurrentWarehouseId(configStore.bins[i].locationId);
              this.changeFilters();
              break;
            }
          }
        } else {
          if (!store.currentWarehouseId)
            store.setCurrentWarehouseId(data.Warehouses[0].Id);
          this.changeFilters();
        }
      } else {
        store.setCurrentWarehouseId(null);
      }
      store.setWarehouses(data.Warehouses);
    });
  };

  refreshContainerRect = () => {
    const { store } = this.props;
    const containerEl = this.containerRef.current;
    if (containerEl) {
      //console.log(containerEl.getBoundingClientRect())
      store.setContainerRect(containerEl.getBoundingClientRect());
    }
  };

  componentDidMount() {
    this.props.socket.on("TransporterMoved", this.onTransporterMoved);
    //this.props.socket.on('InventoryChanged', this.refreshMap);
    this.refreshContainerRect();
    this.refreshMap();

    window.addEventListener("resize", this.resize);

    const { route, store, configStore, socket } = this.props;

    if (route.params.hasOwnProperty("defaultDetailedBin")) {
      const binid = route.params.defaultDetailedBin;

      store.setDetailedBinId(route.params.defaultDetailedBin);
      socket.emitWithToken(
        "GetBinData",
        { BinId: route.params.defaultDetailedBin },
        (err, data) => {
          if (err) {
            console.error("GetBinData", err);
            return;
          }
          store.setBinDetails(route.params.defaultDetailedBin, data);
        },
      );
    }
  }

  componentWillUnmount() {
    this.props.socket.off("TransporterMoved", this.onTransporterMoved);
    //this.props.socket.off('InventoryChanged', this.refreshMap)

    window.removeEventListener("resize", this.resize);
  }

  componentDidUpdate(prevProps) {
    const { currentWarehouseId } = this.props;
    const containerEl = this.containerRef.current;
    if (prevProps.currentWarehouseId !== currentWarehouseId && containerEl) {
      for (let child of containerEl.children) {
        child.style.display = "none";
      }
      for (let child of containerEl.children) {
        child.style.display = "";
      }
    }
    //console.log(document.getElementById('map__wh-container').getBoundingClientRect())
    this.refreshContainerRect();
  }

  shouldComponentUpdate() {
    console.log("should");
  }

  changeFilters = () => {
    const { socket, store } = this.props;
    socket.emitWithToken(
      "GetWarehouseSaturation",
      {
        WarehouseId: store.currentWarehouseId,
        ItemId: store.itemid ? store.itemid.value : null,
        Date: store.date ? formatDateOnly(store.date) : null,
        WorkShift: store.workshift ? store.workshift.value : null,
      },
      (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        store.setWarehouseSaturations(data);
      },
    );
  };

  onTransporterMoved = (data) => {
    if (data && data.Vehicle) {
      this.props.store.setVehicle(data.Vehicle, data);
    }
  };

  resize = () => {
    this.refreshContainerRect();
  };

  printWarehouseMap = (currentWarehouse, showNames) => {
    if (!currentWarehouse) return;

    currentWarehouse.showNames = showNames;

    const html = PRINT_TEMPLATE.replace(
      "{{TITLE}}",
      escapeHtml(currentWarehouse.Name || currentWarehouse.Id || "Nyomtatás"),
    ).replace("{{MAP_JSON}}", JSON.stringify(currentWarehouse));

    this.printHtmlViaIframe(html);
  };

  printHtmlViaIframe = (html) => {
    const iframe = document.createElement("iframe");

    Object.assign(iframe.style, {
      position: "fixed",
      left: "-10000px",
      top: "0",
      width: "297mm", // Landscape szélesség
      height: "210mm",
      border: "0",
    });

    document.body.appendChild(iframe);
    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(html);
    // Kényszerítsük a böngészőt a háttérszínek nyomtatására
    const forceColors = doc.createElement("style");
    forceColors.innerHTML = `
    * { 
      -webkit-print-color-adjust: exact !important; 
      print-color-adjust: exact !important; 
    }
  `;
    doc.head.appendChild(forceColors);
    doc.close();

    // Fontos: a képek/stílusok betöltése után hívjuk meg
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          if (iframe.parentNode) document.body.removeChild(iframe);
        }, 1000);
      }, 500);
    };
  };

  render() {
    const { router, configStore, store } = this.props;
    const { items } = configStore;
    const {
      warehouses,
      currentWarehouse,
      scaled,
      currentWarehouseVehicles,
      currentWarehouseId,
      detailedBinView,
      warehouseSaturations,
    } = this.props.store;

    const warehousesaturation =
      detailedBinView && warehouseSaturations[detailedBinView.Id]
        ? Object.values(warehouseSaturations[detailedBinView.Id]).reduce(
            (acc, curr) => (acc += curr),
            0,
          )
        : 0;

    return (
      <Frame>
        <div className="map">
          <div
            id="map__wh-container"
            className="map__wh-container"
            ref={this.containerRef}
          >
            {currentWarehouse !== null && (
              <div
                className="map__wh"
                style={{
                  width: scaled(currentWarehouse.Dimensions.Width),
                  height: scaled(currentWarehouse.Dimensions.Height),
                }}
              >
                {currentWarehouse.Elements.Bases
                  ? currentWarehouse.Elements.Bases.map((area, areaIndex) => (
                      <MapArea key={"b-" + areaIndex} type="base" area={area} />
                    ))
                  : null}
                {currentWarehouse.Elements.Walls
                  ? currentWarehouse.Elements.Walls.map((area, areaIndex) => (
                      <MapArea key={"w-" + areaIndex} type="wall" area={area} />
                    ))
                  : null}
                {currentWarehouse.Elements.InactiveAreas
                  ? currentWarehouse.Elements.InactiveAreas.map(
                      (area, areaIndex) => (
                        <MapArea
                          key={"a-" + areaIndex}
                          type="inactive"
                          area={area}
                        />
                      ),
                    )
                  : null}
                {currentWarehouse.Corridors.map((corridor, corridorIndex) => (
                  <MapCorridor key={"c-" + corridorIndex} corridor={corridor} />
                ))}
                {currentWarehouseVehicles.map((vehicle, vehicleIndex) => (
                  <MapVehicle key={"v-" + vehicleIndex} vehicle={vehicle} />
                ))}
              </div>
            )}
          </div>
          <div className="map__sidebar">
            {warehouses && (
              <div className="map__wh-selector">
                <div className="sidebar-title">Raktár</div>
                <MySelect
                  warehouses={this.props.store.warehouses}
                  currentWarehouse={this.props.store.currentWarehouse}
                  changeWarehouse={this.changeFilters}
                  refreshContainerRect={this.refreshContainerRect}
                  store={store}
                />
              </div>
            )}
            <div className="map__wh-selector">
              <div className="sidebar-title">Faj-fajta</div>
              <Select
                className="react-select"
                placeholder="Összes"
                options={Object.entries(configStore.items).map(
                  ([id, text]) => ({ value: id, label: text }),
                )}
                onChange={(e) => {
                  store.setItemid(e ? e : null);
                  this.changeFilters();
                }}
                value={store.itemid}
                isClearable={true}
                isSearchable={true}
                styles={SelectStyle}
                components={{ DropdownIndicator }}
              />
            </div>
            <div className="map__wh-selector">
              <div className="sidebar-title">Műszak</div>
              <DatePicker
                id="workshift-datepicker"
                className="stats input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={this.props.store.date}
                onChange={(date) => {
                  store.setDate(date);
                  this.changeFilters();
                }} /*locale='hu'*/
              />
              <Select
                className="react-select"
                placeholder=""
                options={configStore.workshifts.map((workshift) => ({
                  value: workshift,
                  label: workshift,
                }))}
                onChange={(e) => {
                  this.props.store.setWorkShift(e ? e : null);
                  this.changeFilters();
                }}
                value={store.workshift}
                isClearable={true}
                styles={SelectStyle}
                components={{ DropdownIndicator }}
              />
            </div>
            <div className="map__wh-selector">
              {detailedBinView ? null : (
                <div className="">
                  Válasszon ki egy sort a részletes adatok megjelenítéséhez!
                </div>
              )}
            </div>

            <button
              className="btn"
              onClick={(e) => {
                this.printWarehouseMap(currentWarehouse);
              }}
            >
              Nyomtatás
            </button>

            <button
              className="btn"
              onClick={(e) => {
                this.printWarehouseMap(currentWarehouse, true);
              }}
            >
              Nyomtatás (nevekkel)
            </button>
          </div>
          <ReactCSSTransitionGroup
            transitionName="detailsbin_trans"
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {detailedBinView && (
              <div className="map__sidebar" key="detailstransitionkey">
                <div className="bin__details">
                  <div className="bin_details-id">
                    <div className="sidebar-title">Aktuális sor</div>
                    {detailedBinView ? (
                      <div
                        className="btn btn--inline"
                        onClick={() =>
                          router.navigate(ROUTE_TABLE, {
                            search: detailedBinView.Id,
                          })
                        }
                      >
                        {detailedBinView.Id}
                      </div>
                    ) : (
                      <div className="">
                        Válasszon ki egy sort a részletes adatok
                        megjelenítéséhez!
                      </div>
                    )}
                  </div>
                  {detailedBinView &&
                    warehouseSaturations.hasOwnProperty(detailedBinView.Id) && (
                      <div className="bin__details-circles">
                        <svg
                          viewBox="0 0 220 220"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="110"
                            cy="110"
                            r="100"
                            fill="none"
                            stroke="grey"
                            strokeDasharray={"471 628"}
                            strokeWidth={12}
                          />
                          <circle
                            cx="110"
                            cy="110"
                            r="100"
                            fill="none"
                            stroke="orange"
                            strokeDasharray={
                              (detailedBinView.Capacity === 0
                                ? 0
                                : (warehousesaturation /
                                    (detailedBinView.Capacity *
                                      detailedBinView.LevelNum)) *
                                  471) + " 628"
                            }
                            strokeWidth={12}
                          />
                        </svg>
                        <div className="bin__details-circles-label">
                          <div>{warehousesaturation}db</div>
                          <span>
                            {Math.ceil(
                              (detailedBinView.Capacity === 0
                                ? 0
                                : warehousesaturation /
                                  detailedBinView.Capacity /
                                  detailedBinView.LevelNum) * 100,
                            )}
                            %
                          </span>
                        </div>
                      </div>
                    )}
                  {detailedBinView && (
                    <div className="bin__contents">
                      {detailedBinView.Levels.map((level, idx) => {
                        return (
                          <div className="bin__content-level">
                            <span>
                              {detailedBinView.LevelNum - 1 - idx}. SZINT (
                              {level.PalletCount} db raklap)
                            </span>
                            {level.Items.map((item) => {
                              return (
                                <div className="bin__content-item">
                                  <div className="bin__content-label">
                                    {item.Name}
                                  </div>
                                  <div className="bin__content-value">
                                    {item.Quantity}kg
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {false && detailedBinView && (
                    <div className="bin__contents">
                      {Object.entries(detailedBinView.Quantities).map(
                        ([itemId, quantity]) =>
                          items.hasOwnProperty(itemId) ? (
                            <div className="bin__content">
                              <div className="bin__content-label">
                                {items[itemId]}
                              </div>
                              <div className="bin__content-value">
                                {numberFormatter.format(quantity)} kg
                              </div>
                            </div>
                          ) : null,
                      )}
                      <div className="bin__content bin__content--sum">
                        <div className="bin__content-label">Összesen</div>
                        <div className="bin__content-value">
                          {numberFormatter.format(
                            detailedBinView.TotalQuantity,
                          )}{" "}
                          kg
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </ReactCSSTransitionGroup>
        </div>
      </Frame>
    );
  }
}

class MySelect extends React.PureComponent {
  componentWillUpdate = () => {
    console.log("component will update");
  };

  render() {
    const { warehouses, currentWarehouse, store } = this.props;

    return (
      <Select
        className="react-select"
        options={warehouses.map((wh) => ({ value: wh.Id, label: wh.Name }))}
        value={{ value: currentWarehouse.Id, label: currentWarehouse.Name }}
        onChange={(e) => {
          store.setCurrentWarehouseId(e.value);
          this.props.changeWarehouse();
          this.props.refreshContainerRect();
        }}
        isClearable={false}
        isSearchable={false}
        styles={SelectStyle}
        components={{ DropdownIndicator }}
      />
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_MAP}>
    {(routeProps) => <Map {...routeProps} {...props} />}
  </RouteNode>
);

export {
  DIRECTION_LEFT,
  DIRECTION_BOTTOM,
  DIRECTION_RIGHT,
  DIRECTION_TOP,
  getDirectionFromVector,
};
